import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

const UsersList = ({ userArray = [] }) => {
  const staticBounceVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      opacity: 1,
      scale: [0.3, 1.15, 0.85, 1.1, 0.95],
      transition: { duration: 0.7 },
    },
    exit: {
      scale: [0.95, 0.85, 1.1, 0.2],
    },
  };

  return (
    <div className="user-profile-container">
      <div className="avatar-container">
        {userArray?.map((user, index) => (
          <motion.img
            key={index}
            variants={staticBounceVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            alt=""
            src={user.profile_image}
            className="avatar-profile"
          />
        ))}
      </div>
      {userArray.length > 4 && (
        <h2 className="lie-text">+{userArray.length - 4}</h2>
      )}
    </div>
  );
};

export default UsersList;
